// eslint-disable-next-line no-undef
__webpack_public_path__ = `/${window.location.pathname.split('/')[1]}/`;
